import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell, { authStyles } from "../../../components/usuarios_tienda/AuthShell";
import { solicitarReset } from "../../../services/usuarios_tienda/invitaciones";

const LOGIN_PATH = "/administracion/tienda/login";

function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [correo, setCorreo] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await solicitarReset(correo);
      setSent(true);
    } catch (err) {
      // La respuesta es genérica; cualquier error real se muestra discretamente.
      setError(err?.message || "No se pudo procesar la solicitud.");
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <AuthShell title="Revisa tu correo" subtitle="Te enviamos las instrucciones.">
        <div style={{ ...authStyles.alert, ...authStyles.alertOk }}>
          Si el correo está registrado, recibirás un enlace para restablecer tu contraseña. El enlace vence en 1 hora.
        </div>
        <button style={authStyles.primaryBtn} onClick={() => navigate(LOGIN_PATH)}>
          Volver al inicio de sesión
        </button>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title="¿Olvidaste tu contraseña?"
      subtitle="Ingresa tu correo y te enviaremos un enlace para restablecerla."
    >
      {error && <div style={{ ...authStyles.alert, ...authStyles.alertError }}>{error}</div>}

      <form onSubmit={handleSubmit}>
        <div style={authStyles.field}>
          <label style={authStyles.label}>Correo electrónico</label>
          <input
            type="email"
            value={correo}
            onChange={(e) => setCorreo(e.target.value)}
            style={authStyles.input}
            placeholder="tu@correo.com"
            required
            autoFocus
          />
        </div>
        <button type="submit" style={{ ...authStyles.primaryBtn, opacity: submitting ? 0.8 : 1 }} disabled={submitting}>
          {submitting ? "Enviando…" : "Enviar enlace"}
        </button>
      </form>

      <div style={{ marginTop: 16 }}>
        <button type="button" style={authStyles.link} onClick={() => navigate(LOGIN_PATH)}>
          Volver al inicio de sesión
        </button>
      </div>
    </AuthShell>
  );
}

export default ForgotPasswordPage;
